/**
 * @generated SignedSource<<1a8db9da55fd646f37a9fe415b7d7181>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type oneSectionTopWidgetHomeV2Queue$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
    readonly " $fragmentSpreads": FragmentRefs<"homeSecondaryV2ContentItemContent" | "leadSectionTopHomeV2Content">;
  };
  readonly " $fragmentType": "oneSectionTopWidgetHomeV2Queue";
}>;
export type oneSectionTopWidgetHomeV2Queue$key = ReadonlyArray<{
  readonly " $data"?: oneSectionTopWidgetHomeV2Queue$data;
  readonly " $fragmentSpreads": FragmentRefs<"oneSectionTopWidgetHomeV2Queue">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "oneSectionTopWidgetHomeV2Queue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeSecondaryV2ContentItemContent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "leadSectionTopHomeV2Content"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "832c9d503ca82c15c2a08810df6b59c8";

export default node;
